import { confetti } from '@tsparticles/confetti'
import type { SingleOrMultiple } from '@tsparticles/engine'

type ConfettiOptions = {
  count?: number;
  spread?: number;
  scalar?: number;
  decay?: number;
  drift?: number;
  position?: {
    x: number;
    y: number;
  };
  gravity?: number;
  startVelocity?: number;
  colors?: string[];
  shapeOptions?: Record<string, SingleOrMultiple<unknown>>;
  shapes?: SingleOrMultiple<string>;
};

export const useConfetti = (id: string = 'confetti-container') => {

  async function showConfetti(options?: ConfettiOptions): Promise<void> {
    await confetti(id, {
      count: options?.count ?? 70,
      spread: options?.spread ?? 100,
      scalar: options?.scalar ?? 3,
      position: options?.position ?? {
        x: 50,
        y: 50,
      },
      gravity: options?.gravity ?? 0.5,
      startVelocity: options?.startVelocity ?? 30,
      colors: options?.colors,
      shapeOptions: options?.shapeOptions,
      shapes: options?.shapes,
      decay: options?.decay,
      drift: options?.drift ?? 0,
    })
  }

  return {
    showConfetti,
  }
}
